import { Modal } from '../common/Modal'
import { Button } from '../common/Button'

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  employeeName,
  isDeleting
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Employee"
      size="sm"
    >
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="flex-1">
            <p className="text-sm text-slate-600">This action cannot be undone</p>
          </div>
        </div>

        <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-slate-900 font-medium mb-2">
            Are you sure you want to delete <span className="text-red-600 font-semibold">{employeeName}</span>?
          </p>
          <div className="flex items-start gap-3 mt-4">
            <svg className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="flex-1">
              <p className="text-sm font-semibold text-amber-900 mb-2">The following will be deleted:</p>
              <ul className="text-sm text-amber-800 space-y-1 list-disc list-inside">
                <li>All project allocations</li>
                <li>All KRA assignments and allocations</li>
                <li>All goals and milestones</li>
                <li>All employee skills</li>
                <li>All certificates</li>
                <li>Hierarchy relationships</li>
              </ul>
              <p className="text-sm font-semibold text-amber-900 mt-3">Subordinates will have their reporting manager set to None.</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-200 bg-slate-50 -mx-6 -mb-6 px-6 py-4 rounded-b-lg mt-6">
          <Button
            variant="secondary"
            onClick={onClose}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={isDeleting}
            loadingText="Deleting..."
            size="sm"
          >
            Delete Employee
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteConfirmationModal
